import type {
  GetActiveMarketingCampaignsResponse,
  MarketingMergeGuestStateResponse,
  MarketingMarkShownResponse,
  MarketingSubjectType,
  MarketingTrackEventResponse,
  MarketingTrackField,
} from '~/grpc/generated/content_pb.js'

export interface ApiMarketingSubject {
  type: MarketingSubjectType
  id: string
}

export async function apiMarketingGetActive(props: { subject: ApiMarketingSubject }) {
  return await useGrpcQuery<GetActiveMarketingCampaignsResponse>(async ({ clients }) => {
    return await clients.marketing.getActiveCampaigns({ subject: props.subject })
  })
}

export async function apiMarketingTrackEvent(props: {
  subject: ApiMarketingSubject
  campaignId: string
  field: MarketingTrackField
  delta: number
}) {
  return await useGrpcQuery<MarketingTrackEventResponse>(async ({ clients }) => {
    return await clients.marketing.trackEvent({
      subject: props.subject,
      campaignId: props.campaignId,
      field: props.field,
      delta: props.delta,
    })
  })
}

export async function apiMarketingMarkShown(props: { subject: ApiMarketingSubject, campaignId: string }) {
  return await useGrpcQuery<MarketingMarkShownResponse>(async ({ clients }) => {
    return await clients.marketing.markShown({ subject: props.subject, campaignId: props.campaignId })
  })
}

export async function apiMarketingMergeGuestState(props: { guestClientId: string }) {
  return await useGrpcQuery<MarketingMergeGuestStateResponse>(async ({ clients }) => {
    return await clients.marketing.mergeGuestState({ guestClientId: props.guestClientId })
  })
}
